import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Users, Car, FileText, Receipt, Brain, ArrowRight } from "lucide-react";

const Stat = ({ icon: Icon, label, value, to, testid }) => (
  <Link to={to} data-testid={testid} className="page-card hover:border-zinc-400 transition group">
    <div className="flex items-center justify-between">
      <Icon size={18} className="text-zinc-400" />
      <ArrowRight size={16} className="text-zinc-300 group-hover:text-zinc-700 transition" />
    </div>
    <div className="text-4xl font-display mt-6">{value}</div>
    <div className="text-sm text-zinc-500 mt-1">{label}</div>
  </Link>
);

export default function DashboardPage() {
  const [counts, setCounts] = useState({ clients: 0, vehicles: 0, quotes: 0, invoices: 0, models: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const [c, v, q, i, m] = await Promise.all([
          api.get("/clients"), api.get("/vehicles"), api.get("/quotes"), api.get("/invoices"), api.get("/ai/models")
        ]);
        setCounts({
          clients: c.data.length, vehicles: v.data.length, quotes: q.data.length,
          invoices: i.data.length, models: m.data.length,
        });
      } catch (_) {}
    };
    load();
  }, []);

  return (
    <div data-testid="dashboard-page">
      <div className="mb-10">
        <h1 className="font-display text-5xl">Bienvenido</h1>
        <p className="text-zinc-500 mt-2">Resumen rápido de tu taller PDR.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <Stat icon={Users} label="Clientes" value={counts.clients} to="/clientes" testid="stat-clients" />
        <Stat icon={Car} label="Expedientes" value={counts.vehicles} to="/expedientes" testid="stat-vehicles" />
        <Stat icon={FileText} label="Presupuestos" value={counts.quotes} to="/presupuestos" testid="stat-quotes" />
        <Stat icon={Receipt} label="Facturas" value={counts.invoices} to="/facturas" testid="stat-invoices" />
        <Stat icon={Brain} label="Modelos IA" value={counts.models} to="/ia" testid="stat-models" />
      </div>
    </div>
  );
}
